module.exports = __webpack_public_path__ + "static/media/golfer-6-a.6fdcc0d8.png";